import { RenderPlayer } from "./RenderPlayer.js";
import { PlayerManager } from "../Data/PlayerManager.js";
import { DVEPBabylonSystem } from "./System/Babylon.js";
import { SetUpPlayerData } from "../Data/SetUpPlayerData.js";
export async function INIT_RENDER_PLAYER(scene, camera, DVER, system, playerModel) {
    DVEPBabylonSystem.$INIT(DVER, system);
    await SetUpPlayerData(DVER);
    PlayerManager.physics.eyeLevel = 0.7;
    playerModel.isVisible = false;
    //move camera to player's eye level
    camera.position.y = PlayerManager.physics.eyeLevel;
    camera.inputs.removeByType("FreeCameraKeyboardMoveInput");
    camera.minZ = 0.01;
    //set up camera
    const camNode = new DVEPBabylonSystem.DVERSystem.TransformNode("camnode", scene);
    camera.parent = camNode;
    //@ts-ignore
    camNode.parent = playerModel;
    //set up floating origin
    const oriign = new DVEPBabylonSystem.DVERSystem.Vector3();
    scene.onBeforeActiveMeshesEvaluationObservable.add(() => {
        oriign.x = PlayerManager.physics.position.x;
        oriign.y = PlayerManager.physics.position.y;
        oriign.z = PlayerManager.physics.position.z;
    });
    DVER.render.fo.setOriginCenter(scene, { position: oriign });
    const renderPlayer = new RenderPlayer(PlayerManager, {
        model: playerModel,
        //@ts-ignore
        camNode: camNode,
        camera: camera,
        scene: scene,
    });
    scene.registerBeforeRender(() => {
        renderPlayer.render();
    });
    return renderPlayer;
}
